import { useEffect, useState } from 'react';

/**
 * Debounce a value by the given delay (ms).
 * Returns the debounced value that only updates after the delay has passed
 * since the last change to the input value.
 */
export const useDebounce = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};
